export default __webpack_public_path__ + "static/media/fazerBemImage.6865373f.png";